import React from 'react'
import { CButton, CModal, CModalBody, CModalHeader, CModalTitle, CModalFooter } from '@coreui/react';
import { Flex, Input, Typography, Select, Upload, Button, Switch } from 'antd';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { MaskedInput } from 'antd-mask-input';
import { stocksAction } from 'src/store/Slices/Administrator/StocksSlice';
import { getClubs } from 'src/store/Slices/DropDownSlice';
import { UploadOutlined } from '@ant-design/icons';

const AddEditStocksModal = ({ visible, setVisible, stockInfo }) => {

    const dispatch = useDispatch()
    const clubs = useSelector(state => state.DropDownSlice.clubs)

    const [name, setName] = useState()
    const [description, setDescription] = useState()
    const [url, setUrl] = useState()
    const [urlText, setUrlText] = useState()
    const [linkUrl, setLinkUrl] = useState()
    const [visibleUrl, isVisibleUrl] = useState()
    const [clubId, setClubId] = useState()
    const [fileList, setFileList] = useState([]);
    const [uploading, setUploading] = useState(false)

    useEffect(() => {
        setName()
        setDescription()
        setUrl()
        setClubId()
        setFileList([])
        isVisibleUrl(false)
        setUrlText()
        setLinkUrl()
    }, [visible.flag])

    useEffect(() => {
        if (visible.flag === 'edit') {
            setName(stockInfo?.name)
            setDescription(stockInfo?.description)
            setUrl(stockInfo?.imageUrl?.props?.src)
            setClubId(clubs?.data?.value?.find(el => el.label === stockInfo?.clubName)?.value)
            isVisibleUrl(stockInfo?.isLink)
            setUrlText(stockInfo?.linkText)
            setLinkUrl(stockInfo?.linkUrl)
        }
    }, [visible, stockInfo])

    const onClickSubmit = () => {
        const formData = new FormData();
        fileList.forEach((file) => {
            formData.append('imageFile', file);
        });
        formData.append('id', visible.flag !== 'add' ? stockInfo?.id : null,)
        formData.append('name', name);
        formData.append('description', description);
        formData.append('imageUrl', url);
        formData.append('clubId', clubId);
        formData.append('isLink', visibleUrl)
        formData.append('linkText', urlText)
        formData.append('linkUrl', linkUrl)

        setUploading(true)
        dispatch(stocksAction({
            flag: visible.flag === 'add' ? 'put' : 'post', value: formData
        })).then(() => {
            dispatch(stocksAction({ flag: 'get' })).then(() => {
                setVisible({ open: false, flag: '' })
                setUploading(false)
            })
        })
    }

    
    useEffect(() => {
        if (visible.flag === 'edit') {
            dispatch(getClubs())
        }
    }, [visible])

    const handleChange = (info) => {
        if (info.fileList.length === 0) {
            setFileList([])
        } else {
            let newFileList = [...fileList];
            newFileList = newFileList.slice(-1);

            setFileList(newFileList);
        }
 
    };

    
    const props = {
        onRemove: () => {
            setFileList([])
        },
        onChange: handleChange,
        beforeUpload: (file) => {
            if (file.size > 1048576) {
                openNotification({
                    type: 'error',
                    message: 'Размер файла должен быть меньше одного мегабайта'
                })
                return false
            }
            setFileList([...fileList, file]);
            return false;
        },
        fileList,
    };


    return (
        <CModal
            alignment="center"
            visible={visible.open}
            aria-labelledby="VerticallyCenteredExample"
            onClose={() => { setVisible({ open: false, flag: '' }) }}
            keyboard={true}
        >
            <CModalHeader>
                <CModalTitle id="VerticallyCenteredExample">{
                    visible.flag === 'add' ? 'Добавить акцию' : 'Редактировать акцию'
                }</CModalTitle>
            </CModalHeader>
            <CModalBody style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>

                <Flex vertical gap={16} style={{ marginTop: '20px' }}>
                    <>
                        <div>
                            <Typography.Title level={5}>Наименование</Typography.Title>
                            <Input
                                value={name}
                                onChange={e => setName(e.currentTarget.value)}
                            />
                        </div>

                        <div>
                            <Typography.Title level={5}>Описание</Typography.Title>
                            <Input
                                value={description}
                                onChange={e => setDescription(e.currentTarget.value)}
                            />
                        </div>

                        <div>
                            <Typography.Title level={5}>Клуб</Typography.Title>
                            <Select
                                style={{ width: '100%' }}
                                placeholder='Выбрать'
                                onClick={() => { visible.flag === 'add' && dispatch(getClubs()) }}
                                value={clubId}
                                onChange={(e) => { setClubId(e) }}
                                options={clubs?.data?.value}

                            />
                        </div>
                        <div>
                        <Typography.Title level={5}>Вывод полей гиперссылки</Typography.Title>
                        <Switch
                            value={visibleUrl}
                            onChange={(checked) => isVisibleUrl(checked)}
                            style={{width: '50px'}}
                        >
                        </Switch>
                        </div>
                        { visibleUrl &&
                        <>
                            <div>
                                <Typography.Title level={5}>Текст гиперссылки</Typography.Title>
                                <Input
                                    value={urlText}
                                    onChange={e => setUrlText(e.currentTarget.value)}
                                />
                            </div>
                            <div>
                                <Typography.Title level={5}>Гиперссылка</Typography.Title>
                                <Input
                                    value={linkUrl}
                                    onChange={e => setLinkUrl(e.currentTarget.value)}
                                />
                            </div>
                        </>
                        }
                        <div>
                            <Typography.Title level={5}>URL изображение</Typography.Title>
                            <Input
                                value={url}
                                onChange={e => setUrl(e.currentTarget.value)}
                            />
                        </div>

                        <div>
                            <Typography.Title level={5}>Изображение (размер меньше 1 МБ)</Typography.Title>
                            <Upload accept='.png,.jpg,.jpeg' {...props}>
                                <Button icon={<UploadOutlined />}>Выберите файл</Button>
                            </Upload>
                        </div>
                    </>
                </Flex>

            </CModalBody>
            <CModalFooter>
                <CButton
                    onClick={() => { setVisible({ open: false, flag: '' }) }}
                    className='text-light'
                    color="secondary"
                >
                    Закрыть
                </CButton>
                <CButton onClick={onClickSubmit} className='text-light'>
                    {visible.flag === 'add' ? 'Добавить' : 'Редактировать'}
                </CButton>
            </CModalFooter>
        </CModal>
    )
}

export default AddEditStocksModal